module.exports = __webpack_public_path__ + "images/category_lp/furniture/main-view_619b497f77de9fb106dbf66c78fe1f61.png";